import AHttpService from '@d-services/a-http-service/a-http-service';
import URLS from '@d-shared/urls/urls';

class AccountService extends AHttpService {
  async logOut() {
    const response = await this._http.delete(URLS.app.signOut);
    return response.data;
  }
}

export default new AccountService();
